<template>
  <div>
    <cobranca-cadastro-modal
        v-if="modalAdicionarCobranca"
        v-model="modalAdicionarCobranca"
        :pacienteId="idPaciente"
        :atendimentoId="idAtendimento"
        @fecharModalCadastro="fecharModalCadastroCobranca"
    />
    <cobranca-edicao-modal
        v-if="modalEditarCobranca"
        v-model="modalEditarCobranca"
        :id-cobranca="idCobranca"
        @fecharModalEdicao="fecharModalEdicaoCobranca"
    />
    <div class="header-gerenciamento-cobrancas">
      <span class="primary--text">Gerenciamento de cobranças</span>
    </div>
    <div class="container-acoes-cobrancas" v-if="statusAtendimento === 'EM_ANDAMENTO'">
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="primary" depressed @click="adicionarCobranca">
            <v-icon>mdi-cash-multiple</v-icon>
          </v-btn>
        </template>
        Adicionar cobrança
      </v-tooltip>
      <div style="display: flex">
        <div class="container-total mr-8">
          <span>Total</span><br/>
          <label>{{ valorTotalGeral | valorParaReal }}</label>
        </div>
        <div class="container-total">
          <span>Total Pago</span><br/>
          <label>{{ valorTotalPago | valorParaReal }}</label>
        </div>
      </div>
    </div>
    <v-container fluid grid-list-xl white class="pa-0">
      <odontograma-gerenciar-cobrancas-tabela
          :itens="itens"
          :paginas="paginas"
          :total-itens="totalItens"
          :paginacao="$store.state.cobranca.resultadoBuscaTodasCobrancasAtendimento.paginacao"
          @acessar="tratarEventoAcessarCobranca"
          @paginar="tratarEventoPaginar"
      />
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'
import {mapMutations} from 'vuex'
import {actionTypes, mutationTypes} from '@/core/constants'
import CobrancaEdicaoModal from '@/views/modais/CobrancaEdicaoModal.vue'
import CobrancaCadastroModal from '@/views/modais/CobrancaCadastroModal.vue'
import OdontogramaGerenciarCobrancasTabela
from '@/views/pages/cadastros/paciente/comum/odontograma/cobrancas/OdontogramaGerenciarCobrancasTabela.vue'

export default {
    name: 'OdontogramaGerenciarCobrancas',
    props: {
        idAtendimento: {
            type: Number,
            required: true
        },
        statusAtendimento: {
            type: String,
            required: true
        },
    },
    components: {
        OdontogramaGerenciarCobrancasTabela, CobrancaCadastroModal, CobrancaEdicaoModal
    },
    data() {
        return {
            filtrosInterno: this.getFiltros(),
            modalAdicionarCobranca: false,
            modalEditarCobranca: false,
            idPaciente: null,
            idCobranca: null,
            itens: [],
            paginas: 0,
            totalItens: 0,
            valorTotalGeral: 0,
            valorTotalPago: 0,
        }
    },
    mounted() {
        this.setarDadosIniciais()
    },
    methods: {
        ...mapMutations([
            mutationTypes.COBRANCA.SET_FILTROS_BUSCA_TODAS_COBRANCAS_ATENDIMENTO,
            mutationTypes.COBRANCA.SET_PAGINACAO_BUSCA_TODAS_COBRANCAS_ATENDIMENTO,
        ]),
        setarDadosIniciais() {
            if (this.$route.params.id) {
                this.idPaciente = Number(this.$route.params.id)
            }
        },
        async buscar() {
            this.setFiltrosBuscaTodasCobrancasAtendimento(this.getFiltrosInterno())
            await this.buscarCobrancas()
        },
        async buscarCobrancas() {
            const resposta = await this.$store.dispatch(actionTypes.COBRANCA.BUSCAR_TODAS_COBRANCAS_ATENDIMENTO, this.idAtendimento)
            if (resposta) {
                this.itens = resposta.items
                this.paginas = resposta.totalPages
                this.totalItens = resposta.totalElements
                this.valorTotalGeral = resposta.valorTotalGeral
                this.valorTotalPago = resposta.valorTotalPago
            }
        },
        getFiltros() {
            return _.cloneDeep(this.$store.state.cobranca.resultadoBuscaTodasCobrancasAtendimento.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        tratarEventoPaginar(paginacao) {
            this.setPaginacaoBuscaTodasCobrancasAtendimento(paginacao)
            this.buscar()
        },
        tratarEventoAcessarCobranca(item) {
            this.idCobranca = item.id
            this.modalEditarCobranca = true
        },
        fecharModalEdicaoCobranca() {
            this.modalEditarCobranca = false
            this.idCobranca = null
            this.buscar()
        },
        adicionarCobranca() {
            this.modalAdicionarCobranca = true
        },
        fecharModalCadastroCobranca() {
            this.modalAdicionarCobranca = false
            this.buscar()
        },

    }
}
</script>

<style scoped lang="stylus">

.header-gerenciamento-cobrancas
  margin-top 10px
  border-bottom 1px solid #ddd

  span
    font-weight bold

.container-acoes-cobrancas
  margin-top 10px
  display flex
  justify-content space-between

.container-total
  span
    font-weight bold
    color var(--theme-primary)

</style>